import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import './utilities/swalToasts';

// Suppress the benign ResizeObserver loop warning. It's a browser notification
// that a resize callback didn't finish in one animation frame — harmless.
// We intercept it in both capture and bubble phases so CRA's overlay never sees it.
const suppressResizeObserverError = (e) => {
    if (e.message?.includes('ResizeObserver')) {
        e.stopImmediatePropagation();
        e.preventDefault();
        return true;
    }
};
window.addEventListener('error', suppressResizeObserverError);
window.addEventListener('error', suppressResizeObserverError, true);

// CRA's error overlay also listens on console.error — patch it to block the same class of messages.
const _origConsoleError = console.error;
console.error = (...args) => {
    if (typeof args[0] === 'string' && args[0].includes('ResizeObserver')) return;
    _origConsoleError(...args);
};

// Suppress the benign browser-extension async message error. Chrome extensions
// (e.g. React DevTools) return true from onMessage to signal async response,
// but the port closes on navigation/hot-reload before they respond. Harmless.
window.addEventListener('unhandledrejection', (e) => {
    if (e?.reason?.message?.includes('message channel closed before a response was received')) {
        e.preventDefault();
    }
});

// three.js's Clock deprecation warning is silenced in utilities/threeConsole, loaded with the
// 3D tavern: importing three here would put all of it in the bundle every page loads.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
